import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 1. Import BrowserRouter
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { disableNumberInputScrollGlobally } from './utils/disableNumberInputScroll';

disableNumberInputScrollGlobally();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 2. Wrap your App component */}
    <BrowserRouter>
      <AuthProvider> {/* Wrap App */}
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();